export default "__VITE_ASSET__DJBhKRqE__"